import React from 'react';
import './index.css';
import { Code, Palette, TrendingUp, Smartphone, Globe, Megaphone } from 'lucide-react';
import Footer from '../Footer';
import { Helmet } from 'react-helmet';
import Header from '../Header';
import Navbar from '../Navbar';
import { useMediaQuery } from 'react-responsive';
import NavbarInOtherPage from "../NavbarInOtherPage"

const Service = () => {
  const mediaQueryCondition = useMediaQuery({ query: '(max-width:1024px)' })

    const services = [
        {
            icon: <Code className="service-icon" />,
            title: "Web Development",
            description: "Custom websites built with modern technologies. Responsive, fast, and scalable solutions tailored to your business needs.",
            features: ["React & Next.js", "Custom CMS", "E-commerce Solutions", "API Integration"]
        },
        {
            icon: <Smartphone className="service-icon" />,
            title: "App Development",
            description: "Native and cross-platform mobile applications that deliver exceptional user experiences across all devices.",
            features: ["iOS & Android", "React Native", "Progressive Web Apps", "App Maintenance"]
        },
        {
            icon: <Palette className="service-icon" />,
            title: "Graphic Design",
            description: "Creative visual solutions that capture your brand's essence and communicate your message effectively.",
            features: ["Brand Identity", "UI/UX Design", "Marketing Materials", "Illustrations"]
        },
        {
            icon: <Megaphone className="service-icon" />,
            title: "Digital Marketing",
            description: "Data-driven marketing strategies to boost your online presence and drive meaningful engagement.",
            features: ["SEO Optimization", "Social Media Marketing", "Content Strategy", "Analytics & Reporting"]
        },
        {
            icon: <Globe className="service-icon" />,
            title: "Domain & Hosting",
            description: "Reliable hosting solutions with seamless domain management to keep your website running smoothly.",
            features: ["Domain Registration", "Cloud Hosting", "SSL Certificates", "24/7 Support"]
        },
        {
            icon: <TrendingUp className="service-icon" />,
            title: "Business Consulting",
            description: "Strategic guidance to help your business leverage technology for growth and competitive advantage.",
            features: ["Digital Strategy", "Tech Consulting", "Process Optimization", "Growth Planning"]
        }
    ];

    const processSteps = [
        { step: "01", title: "Discovery", desc: "Understanding your goals and requirements" },
        { step: "02", title: "Planning", desc: "Creating a strategic roadmap" },
        { step: "03", title: "Execution", desc: "Building with precision and care" },
        { step: "04", title: "Launch", desc: "Delivering and supporting your success" }
    ];

    return (
        <>
          <Helmet>
                <title>Connect with InsuCreation: Reach Out for Professional Guidance and Support</title>
                <meta name="description" content="Contact InsuCreation today for expert assistance and personalized solutions. Our team is ready to address your inquiries, provide professional guidance, and offer support tailored to your needs. Reach out now to start the conversation." />
                <meta name="keywords" content="Insu Creation, SEO, digital solutions, web development, marketing strategies, branding, SEO, social media marketing, e-commerce, content creation, online presence, business growth, digital innovation, customer engagement, website optimization, digital transformation, digital agency, online marketing, digital strategy, digital consultancy, digital services, digital expertise" />

            </Helmet>
            <Header />
            {mediaQueryCondition ? <Navbar /> : <NavbarInOtherPage className="navbar-in-contact" />}

        <div className="service-page">
            {/* Hero Section */}
            {/* <div className="hero-section">
                <div className="hero-content">
                    <h1 className="hero-title">Our Services</h1>
                    <p className="hero-subtitle">
                        Empowering your digital journey with comprehensive solutions tailored to your success
                    </p>
                </div>
            </div> */}

            {/* Services Grid */}
            <div className="services-containers">
                <div className="services-grid">
                    {services.map((service, index) => (
                        <div key={index} className="service-card">
                            <div className="service-icon-wrapper">
                                {service.icon}
                            </div>
                            
                            <h3 className="service-title">
                                {service.title}
                            </h3>
                            
                            <p className="service-description">
                                {service.description}
                            </p>
                            
                            <div className="service-features">
                                {service.features.map((feature, idx) => (
                                    <div key={idx} className="feature-item">
                                        <div className="feature-dot"></div>
                                        <span>{feature}</span>
                                    </div>
                                ))}
                            </div>
                            
                            <button className="service-btn">
                                Learn More
                            </button>
                        </div>
                    ))}
                </div>
            </div>

            {/* CTA Section */}
            <div className="cta-section">
                <div className="cta-content">
                    <h2 className="cta-title">
                        Ready to Transform Your Digital Presence?
                    </h2>
                    <p className="cta-subtitle">
                        Let's discuss how we can help your business thrive in the digital world
                    </p>
                    <div className="cta-buttons">
                        <button className="btn-primary">Get Started</button>
                        <button className="btn-secondary">Contact Us</button>
                    </div>
                </div>
            </div>

            {/* Process Section */}
            <div className="process-section">
                <h2 className="section-title">Our Process</h2>
                <p className="section-subtitle">
                    A streamlined approach to deliver exceptional results
                </p>
                
                <div className="process-grid">
                    {processSteps.map((item, idx) => (
                        <div key={idx} className="process-step">
                            <div className="step-number">{item.step}</div>
                            <h3 className="step-title">{item.title}</h3>
                            <p className="step-desc">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
         <Footer />
         </>
    );
};

export default Service;